import Decimal from 'decimal.js';
import { CargoContent } from 'src/types/ViewModel/Stowage/Manifest/CargoContent';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { calculateVolume } from './volumeUtils';
import { getCargoTemperature } from './cargoTemperatureUtils';

/**
 * Returns the highest combined volume of physically commingled previous cargoes at one confirmed tank inventory
 * state, or null when the history entry is not a commingled entry.
 */
export const getPeakCommingledVolume = (stowagePlan: StowagePlan, cargoContent: CargoContent): Decimal | null => {
    if (!cargoContent?.commingledInventoryStates?.length) return null;

    return cargoContent.commingledInventoryStates.reduce((peak, state) => {
        const volume = state.reduce(
            (total, content) => total.plus(calculateVolume(content.weight, content.cargo, getCargoTemperature(stowagePlan, content.cargo))),
            new Decimal(0)
        );
        return Decimal.max(peak, volume);
    }, new Decimal(0));
};
